import React from 'react';

interface Props {
  children: any;
}

const SidebarItemsContainer = ({ children }: Props) => {
  return <div className="w-full p-2">{children}</div>;
};

export default SidebarItemsContainer;
